import { withRouter } from 'react-router-dom';
import Header from './Header';
import withUser from '../context/withUser';

export default withUser(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/common/HeaderContainer.js